import {FC} from 'react'
import {DataCDR} from '../../core/_models'
import {useIntl} from 'react-intl'

type Props = {
  data: DataCDR
}
const CDRStatus: FC<Props> = ({data}) => {
  const intl = useIntl()

  return (
    <div className='d-flex align-items-center'>
      <span className='badge badge-light-primary'>
        <span className='small fs-9 text-gray-800 text-uppercase'>
          {data.direction === 'OUTBOUND' && data.status === 'ANSWERED' && data.talk_duration === 0
            ? intl.formatMessage({id: `CDR.STATUS.NO ANSWER`})
            : intl.formatMessage({id: `CDR.STATUS.${data.status}`})}
        </span>
      </span>
    </div>
  )
}

export {CDRStatus}
